import { EventEmitter } from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';

export class TreeviewDirectory {
    public expanded: boolean = true;
    private _active: boolean = true;
    public get active(): boolean {
        return this._active;
    }
    public set active(value: boolean) {
        this._active = value;

        this.indeterminateRecursive();
    }
    public checked: boolean = false;
    public visible: boolean = true;
    public indeterminate: boolean = false;

    private _directories: Array<TreeviewDirectory>;
    private _info: any;
    private _files: Array<string>;
    private _parent: TreeviewDirectory;
    private _icon: string;

    private _background: string;

    public dirStatusChanged: EventEmitter<any>;

    constructor(info: Object, directories: Array<TreeviewDirectory>, files: Array<string>, checked: boolean, visible: boolean, active: boolean, icon: string, expanded: boolean = true, background:string="") {
        this.info = info;
        this.directories = directories;
        this.files = files;
        this.dirStatusChanged = new EventEmitter<any>();
        this.icon = icon;
        this.background = background;
        this.expanded = expanded;
        this.active = active;
        this.checked = checked;
        this.visible = visible;
    }

    get directories(): Array<TreeviewDirectory> {
        return this._directories;
    }

    set directories(directories: Array<TreeviewDirectory>) {
        this._directories = directories;

        directories.forEach(dir => {
            dir.parent = this;
        });

        // On vérifie les répertoires enfants pour mettre à jour le statut de l'élément actuel
        this.verifyIndeterminateDirectories();
    }

    get info(): any {
        return this._info;
    }

    set info(info: any) {
        this._info = info;
    }

    get files(): Array<string> {
        return this._files;
    }

    set files(files: Array<string>) {
        this._files = files;
    }

    get parent(): TreeviewDirectory {
        return this._parent;
    }

    set parent(parent: TreeviewDirectory) {
        this._parent = parent;
    }

    get icon(): any {
        return this._icon;
    }

    set icon(icon: any) {
        this._icon = icon;
    }

    get background(): any {
        return this._background;
    }

    set background(background: any) {
        this._background = background;
    }  

    /**
     * Action de plier/déplier un répertoire
     *
     * @memberOf TreeviewDirectory
     */
    public toggle(): void {
        if (this.directories.length > 0) {
            this.expanded = !this.expanded;
        }
    }

    /**
     * Icône, plier/déplier ou spacer
     *
     * @returns {string}
     *
     * @memberOf TreeviewDirectory
     */
    public getIcon(): string {
        if (this._icon) {
            return this._icon;
        } else if (this.directories.length > 0) {
            let classIcon: string = this.expanded ? 'fa-minus' : 'fa-plus';

            return '<i class="fa ' + classIcon + ' hand"></i>';
        } else {
            return '&nbsp;';
        }
    }

    /**
     * Get background image if any
     *
     * @returns {string}
     *
     * @memberOf TreeviewDirectory
     */
    public getBackground(): string {
        if (this._background) {
            let background = 'url(\''+this._background+'\')';
            background = background.replace('/', '\\/');
            return background;
        } else {
            return '';
        }
    }

    /**
     * Tells whether the node has some child nodes
     *
     * @returns {boolean}
     *
     * @memberOf TreeviewDirectory
     */
    public hasDirectories(): boolean {
        return this.directories.length > 0;
    }

    /**
     * Récupère le premier parent d'un répertoire
     *
     * @returns {TreeviewDirectory}
     *
     * @memberOf TreeviewDirectory
     */
    public getFirstParent(): TreeviewDirectory {
        if (this._parent) {
            return this._parent.getFirstParent();
        } else {
            return this;
        }
    }

    /**
     * Action au click sur un répertoire
     * Génère un event un fin de traitement
     *
     * @param {boolean} state
     *
     * @memberOf TreeviewDirectory
     */
    public click(state: boolean): void {
        let previousState: TreeviewDirectory = cloneDeep(this);

        // TODO : quand on est en état indéterminé et que l'on click : passer à décocher (l'inverse du fonctionnement des navigateurs)
        // if (this.indeterminate) {
        // state = false;
        // }

        this.check(state);

        if (this._parent) {
            this._parent.indeterminateRecursive();
        }
        // On renvoie l'état de l'arbre avant et après changement
        let result = {
            "old": previousState,
            "new": this
        };
        // On place l'event à la toute fin pour envoyer un seul event une fois toutes les récursions faite
        this.dirStatusChanged.emit(result);
    }

    /**
     * Changement de l'état d'un repertoire et répercution sur parents et enfants
     *
     * @param {boolean} state
     *
     * @memberOf TreeviewDirectory
     */
    private check(state: boolean): void {
        if (this.active) {
            if (state === undefined) {
                this.checked = !this.checked;
            } else {
                this.checked = state;
            }

            this.indeterminate = false;

            this.directories.forEach(d => {
                d.check(this.checked);
            });
        }
    }

    /**
     * Répercution de l'état d'un repertoire sur ses parents
     *
     * @memberOf TreeviewDirectory
     */
    public indeterminateRecursive(): void {
        this.verifyIndeterminateDirectories();
        if (this._parent) {
            this._parent.indeterminateRecursive();
        }
    }

    public verifyIndeterminateDirectories(): void {
        let dirCount: number = 0;
        let checkedCount: number = 0;
        let indeterminateCount: number = 0;
        let uncheckedCount: number = 0;

        for (let dir of this.directories) {
            if (dir.active) {
                dir.verifyIndeterminateDirectories();
            }
            if (dir.active && dir.visible) {
                dirCount++;

                if (dir.checked) {
                    checkedCount++;
                } else if (dir.indeterminate || (dir.checked && !dir.active)) {
                    indeterminateCount++;
                } else {
                    uncheckedCount++;
                }
            }
        }

        if (dirCount > 0) {
            if (checkedCount === dirCount) {
                this.checked = true;
                this.indeterminate = false;
            } else if (checkedCount > 0 || indeterminateCount > 0) {
                this.checked = false;
                this.indeterminate = true;
            } else if (uncheckedCount === dirCount || indeterminateCount == 0) {
                this.checked = false;
                this.indeterminate = false;
            } else {
                this.checked = false;
                this.indeterminate = true;
            }
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/treeview/treeview-directory.ts